import memoizeLast from 'transmute/memoizeLast';
import { isUtmParameterKeyType } from 'customer-data-filters-ui/types/UtmParametersType';
import isString from 'transmute/isString';
import * as params from 'hub-http/helpers/params';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const UTM_URL = 'UtmUrl';
export const STANDARD_URL = 'StandardUrl';
export const ALLOWED_UTM_PARAMETERS = Object.freeze(['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content']);
export const DISALLOWED_URL_PARAMETERS = Object.freeze([...ALLOWED_UTM_PARAMETERS, 'source', 'guid', 'gclid', 'RewriteStatus', 'rewritestatus', 'hsCtaTracking', 'q', 'submissionGuid', '_hse', '_hsh', '_hsmi', '_hsPrivacyTest', '_hsenc', '__hstc', '__hssc', '__hsfp', 'hsContentSearchTerm', 'hsContentSearchDomain', 'hsContentSearchType', 'hsContentSearchLimit', 'hsContentSearchOffset']);
export const defaultUtmParameters = Object.freeze({
  utm_campaign: '',
  utm_content: '',
  utm_medium: '',
  utm_source: '',
  utm_term: ''
});
export const hasUtmParameterValues = parameters => {
  return ALLOWED_UTM_PARAMETERS.some(key => parameters[key]);
};
export const isValidUtmParameters = parameters => {
  if (parameters) {
    return ALLOWED_UTM_PARAMETERS.every(key => isString(parameters[key]));
  }
  return false;
};
export const hasParameters = url => {
  return url && url.includes('?');
};
export const getProtocol = str => {
  if (/^((http):\/\/)/i.test(str)) {
    return 'http://';
  } else if (/^((https):\/\/)/i.test(str)) {
    return 'https://';
  }
  return undefined;
};
export const getDisplayValue = memoizeLast((str = '') => str.replace(/^((http|https):\/\/)*/i, ''));
export const getFullUrl = (urlString, protocol) => {
  return `${protocol}${urlString}`;
};
export const getFullUtmUrl = (url, utmParameters) => {
  let newUrl = url;
  let first = !url.includes('?');
  ALLOWED_UTM_PARAMETERS.forEach(key => {
    if (utmParameters[key]) {
      if (first) {
        newUrl = `${newUrl}?${key}=${utmParameters[key]}`;
        first = false;
      } else {
        newUrl = `${newUrl}&${key}=${utmParameters[key]}`;
      }
    }
  });
  return newUrl;
};
export const getUtmParameters = urlString => {
  const utmParameters = Object.assign({}, defaultUtmParameters);
  let url;
  try {
    url = new URL(urlString);
  } catch (err) {
    if (err instanceof TypeError) {
      return utmParameters;
    } else {
      throw err;
    }
  }
  url.searchParams.forEach((value, key) => {
    if (isUtmParameterKeyType(key) && value) {
      utmParameters[key] = encodeURIComponent(value);
    }
  });
  return utmParameters;
};
export const getUrlBase = urlString => {
  if (urlString) {
    return urlString.split('?')[0];
  }
  return urlString;
};
export const getQueryParams = location => {
  const queryParams = params.parse(location.search.substring(1));
  return queryParams;
};
export const getUtmUrlInputValidationMessage = (urlDomain, utmParameters, onClick) => {
  if (hasParameters(urlDomain)) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "customerDataFiltersUI.customerDataFilters.FilterOperatorUtmUrlInput.error.parametersInUrl_jsx",
      options: {
        onClick
      },
      elements: {
        Link
      }
    });
  } else if (urlDomain && !hasUtmParameterValues(utmParameters)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.customerDataFilters.FilterOperatorUtmUrlInput.error.utmParameterRequired"
    });
  } else {
    return null;
  }
};
export const mergeUtmParameters = (parameters, defaultParameters) => {
  const utmParameters = Object.assign({}, defaultUtmParameters);
  ALLOWED_UTM_PARAMETERS.forEach(param => utmParameters[param] = parameters[param] || defaultParameters[param]);
  return utmParameters;
};